module.exports = __webpack_public_path__ + "img/top.44dc307.png";